"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderSkeleton = exports.MachineDetail = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const ApiMachineRepo_1 = require("../../modules/machine/infra/ApiMachineRepo");
const machineDetail_module_scss_1 = __importDefault(require("./machineDetail.module.scss"));
const types_1 = require("./types");
const react_i18next_1 = require("react-i18next");
const usePagination_1 = require("../../hooks/pagination/usePagination");
const CardHeader_1 = require("./CardHeader");
const paginationHelpers_1 = require("../../common/utils/paginationHelpers");
const machineDetailsHelpers_1 = require("./utils/machineDetailsHelpers");
const openMachineDoor_1 = require("../../modules/machine/app/openMachineDoor");
const CustomModal_1 = require("../../components/custom-modal/CustomModal");
const GenericButton_1 = require("../../components/web-view/button/GenericButton");
const restartMachine_1 = require("../../modules/machine/app/restartMachine");
const toast_1 = require("primereact/toast");
const updatePriceOrProduct_1 = require("../../modules/machine/app/updatePriceOrProduct");
const ChangeProductModal_1 = require("./change-product/ChangeProductModal");
const react_router_dom_1 = require("react-router-dom");
const useIsMobile_1 = require("../../hooks/mobile/useIsMobile");
const MachineDetail_1 = require("./mobile/MachineDetail");
const useHandleInputChange_1 = __importDefault(require("../../hooks/editProducts/useHandleInputChange"));
const useHandleEdit_1 = __importDefault(require("../../hooks/editProducts/useHandleEdit"));
const DesktopGrid_1 = __importDefault(require("./DesktopGrid"));
const button_1 = require("primereact/button");
const constants_1 = require("../../routes/constants");
const updateStocks_1 = require("../../modules/machine/app/updateStocks");
const skeleton_1 = require("primereact/skeleton");
const WebCard_1 = require("../../components/web-view/card/WebCard");
const getAisleWeight_1 = require("../../modules/machine/app/getAisleWeight");
const getBalance_1 = require("../../modules/machine/app/getBalance");
const getAisleBalance_1 = require("../../modules/machine/app/getAisleBalance");
const resetAisleWeight_1 = require("../../modules/machine/app/resetAisleWeight");
const CalibrationModal_1 = require("./CalibrationModal");
const updateAisleWeight_1 = require("../../modules/machine/app/updateAisleWeight");
const getApiErrorMessage_1 = require("../../common/api/utils/getApiErrorMessage");
const repo = (0, ApiMachineRepo_1.createApiMachineRepo)();
const MachineDetail = ({ id }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [editingAisleId, setEditingAisleId] = (0, react_1.useState)(null);
    const [modalVisible, setModalVisible] = (0, react_1.useState)(false);
    const [actionType, setActionType] = (0, react_1.useState)(null);
    const [itemsToLoad, setItemsToLoad] = (0, react_1.useState)(null);
    const [changeProductModalVisible, setChangeProductModalVisible] = (0, react_1.useState)(false);
    const gridContainerRef = (0, react_1.useRef)(null);
    const productListRef = (0, react_1.useRef)(null);
    const [micronAisleId, setMicronAisleId] = (0, react_1.useState)(null);
    const [aisleCode, setAisleCode] = (0, react_1.useState)(null);
    const [aisles, setAisles] = (0, react_1.useState)([]);
    const [isEditing, setIsEditing] = (0, react_1.useState)(true);
    const [activeRefills, setActiveRefills] = (0, react_1.useState)(false);
    const toast = (0, react_1.useRef)(null);
    const { localValues, handleInputChange, setLocalValues } = (0, useHandleInputChange_1.default)();
    const isMobile = (0, useIsMobile_1.useIsMobile)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [editingField, setEditingField] = (0, react_1.useState)({ micronAisleId: null, field: null });
    const [initialAislesState, setInitialAislesState] = (0, react_1.useState)(null);
    const [openContinueRefillsModal, setOpenContinueRefillsModal] = (0, react_1.useState)(false);
    const [confirmProceed, setConfirmProceed] = (0, react_1.useState)(false);
    const prevItemsToLoad = (0, react_1.useRef)(itemsToLoad);
    const [weights, setWeights] = (0, react_1.useState)({});
    const [loadingWeights, setLoadingWeights] = (0, react_1.useState)({});
    const overlayRefs = (0, react_1.useRef)({});
    const [visiblePopups, setVisiblePopups] = (0, react_1.useState)({});
    const initialStockRefs = (0, react_1.useRef)({});
    const MemoizedDesktopGrid = react_1.default.memo(DesktopGrid_1.default);
    const [showCalibration, setShowCalibration] = (0, react_1.useState)(false);
    const scrollContainerRef = (0, react_1.useRef)(null);
    const [openCalibrationModal, setOpenCalibrationModal] = (0, react_1.useState)(false);
    const [currentAisle, setCurrentAisle] = (0, react_1.useState)(null);
    const [loadingStock, setLoadingStock] = (0, react_1.useState)({});
    const [loadingAllStock, setLoadingAllStock] = (0, react_1.useState)(false);
    const [data, setData] = (0, react_1.useState)();
    const loadingAisles = !data || aisles.length === 0;
    const scrollPosition = (0, react_1.useRef)(0);
    const saveScrollPosition = () => {
        if (scrollContainerRef.current) {
            scrollPosition.current = scrollContainerRef.current.scrollTop;
        }
    };
    const restoreScrollPosition = () => {
        requestAnimationFrame(() => {
            if (scrollContainerRef.current) {
                scrollContainerRef.current.scrollTop = scrollPosition.current;
            }
        });
    };
    (0, react_1.useLayoutEffect)(() => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTop = scrollPosition.current;
        }
    });
    (0, react_1.useEffect)(() => {
        (0, machineDetailsHelpers_1.fetchMachineDetail)(id).then((machineData) => {
            setData(machineData);
        });
    }, []);
    (0, react_1.useEffect)(() => {
        const calculateInitialItemsToLoad = () => {
            const cardHeight = 150;
            const containerHeight = window.innerHeight;
            const itemsInView = Math.ceil(containerHeight / cardHeight);
            const calculatedItemsToLoad = itemsInView + 10;
            if (prevItemsToLoad.current !== calculatedItemsToLoad) {
                setItemsToLoad(calculatedItemsToLoad);
                prevItemsToLoad.current = calculatedItemsToLoad;
            }
        };
        calculateInitialItemsToLoad();
        const handleResize = () => {
            calculateInitialItemsToLoad();
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [itemsToLoad]);
    /* const { data, extraData, loading, fetchData } = usePagination<
      Aisle,
      AislesWithMachineData,
      Machine
    >(
      1,
      10,
      (page, pageSize) => fetchMachineDetail(id, page, pageSize),
      (aisle) => aisle.micronAisleId,
      (result) => result.aisles,
      (result) => result.machine
    )*/
    const { data: productData, loading: productLoading, fetchData: fetchProducts, } = (0, usePagination_1.usePagination)(1, itemsToLoad ?? 10, (page, pageSize) => (0, machineDetailsHelpers_1.fetchAllProducts)(page, pageSize), (product) => product.micronProductId);
    const dataRef = (0, react_1.useRef)(data);
    (0, react_1.useEffect)(() => {
        if (itemsToLoad !== null) {
            if (!changeProductModalVisible)
                return;
            fetchProducts(1, itemsToLoad, false);
        }
    }, [changeProductModalVisible]);
    /*useScrollPosition(() => {
      if (!loading && isNearBottom(gridContainerRef.current)) {
        fetchData(data.pagination.currentPage + 1, itemsToLoad ?? 0, true)
      }
    })*/
    const showSuccess = (message) => {
        if (toast.current) {
            toast.current.show({
                severity: 'success',
                summary: 'Success',
                detail: message,
                life: 5000,
            });
        }
    };
    const showError = (message) => {
        if (toast.current) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: message,
                life: 5000,
            });
        }
    };
    const showWarning = (message) => {
        if (toast.current) {
            toast.current.show({
                severity: 'warn',
                summary: t('warning'),
                detail: message,
                life: 5000,
            });
        }
    };
    const showApiError = (error, fallbackKey) => {
        showError((0, getApiErrorMessage_1.getApiErrorMessage)(t, error, fallbackKey));
    };
    (0, react_1.useEffect)(() => {
        if (data?.aisles) {
            setAisles(data.aisles);
        }
    }, [data]);
    (0, react_1.useEffect)(() => {
        dataRef.current = data;
    }, [data, isEditing]);
    (0, react_1.useEffect)(() => {
        if (isEditing)
            return;
        (0, machineDetailsHelpers_1.fetchMachineDetail)(id).then((machineData) => {
            setData(machineData);
        });
    }, [isEditing]);
    /* const handleContainerScroll = () => {
      if (isNearBottom(gridContainerRef.current) && !loading) {
        fetchDataNextPage(data.pagination, fetchData)
      }
    }*/
    const handleProductScroll = () => {
        if ((0, paginationHelpers_1.isNearBottom)(productListRef.current) && !productLoading) {
            (0, paginationHelpers_1.fetchDataNextPage)(productData.pagination, fetchProducts);
        }
    };
    /*  useEffect(() => {
      const gridContainer = gridContainerRef.current
      if (gridContainer) {
        gridContainer.addEventListener('scroll', handleContainerScroll)
        return () =>
          gridContainer.removeEventListener('scroll', handleContainerScroll)
      }
    }, [loading, data.pagination, fetchData])*/
    (0, react_1.useEffect)(() => {
        const productListContainer = productListRef.current;
        if (productListContainer) {
            productListContainer.addEventListener('scroll', handleProductScroll);
            return () => productListContainer.removeEventListener('scroll', handleProductScroll);
        }
    }, [productLoading, productData.pagination, fetchProducts]);
    const handleEditMode = (micronAisleId, field) => {
        const aisle = aisles.find((aisle) => aisle.micronAisleId === micronAisleId);
        if (aisle) {
            setLocalValues({
                maxStock: aisle.maxStock || 0,
                currStock: aisle.currStock || 0,
                price: aisle.price || 0,
            });
            setEditingAisleId(micronAisleId);
            setEditingField({ micronAisleId, field });
        }
    };
    const handleCloseEditMode = () => {
        saveScrollPosition();
        setEditingAisleId(null);
        restoreScrollPosition();
    };
    const handleOpenCalibrationModal = (0, react_1.useCallback)((aisle) => {
        saveScrollPosition();
        setCurrentAisle(aisle);
        setOpenCalibrationModal(true);
        restoreScrollPosition();
    }, []);
    const handleCloseCalibrationModal = (0, react_1.useCallback)(() => {
        saveScrollPosition();
        setOpenCalibrationModal(false);
        setCurrentAisle(null);
        restoreScrollPosition();
    }, []);
    const toggleEdit = (micronAisleId, micronProductId, aisleCode, closeModal, type, explicitValue) => {
        if (editingAisleId === micronAisleId) {
            // Crear valores actuales basados en el tipo de edición
            const currentValues = {
                ...localValues,
                ...(type === types_1.EditableField.MaxStock && explicitValue !== undefined
                    ? { maxStock: explicitValue }
                    : {}),
                ...(type === types_1.EditableField.Price && explicitValue !== undefined
                    ? { price: explicitValue }
                    : {}),
                ...(type === types_1.EditableField.CurrStock && explicitValue !== undefined
                    ? { currStock: explicitValue }
                    : {}),
            };
            saveScrollPosition();
            handleEdit(micronAisleId, micronProductId, aisleCode, types_1.EditableField.All, currentValues, showSuccess, showError, type).then(() => {
                updateAisleValues(micronAisleId, currentValues);
                closeModal?.();
            });
            setEditingAisleId(null);
            restoreScrollPosition();
        }
    };
    const updateAisleValues = (micronAisleId, values) => {
        setAisles((prevAisles) => {
            const updatedItems = prevAisles.map((aisle) => aisle.micronAisleId === micronAisleId ? { ...aisle, ...values } : aisle);
            return updatedItems;
        });
    };
    const { handleEdit } = (0, useHandleEdit_1.default)({
        repo,
        id,
        updateAisleValues,
    });
    const handleOpenChangeProductModal = (micronAisleId, aisleCode) => {
        if (changeProductModalVisible)
            return;
        setChangeProductModalVisible(true);
        setMicronAisleId(micronAisleId);
        setAisleCode(aisleCode);
    };
    const handleCloseChangeProductModal = () => {
        if (!changeProductModalVisible)
            return;
        setChangeProductModalVisible(false);
        setMicronAisleId(null);
    };
    const handleOpenDoor = async () => {
        if (id) {
            try {
                await (0, openMachineDoor_1.openMachineDoor)(repo, id);
                showSuccess(t('openDoorSuccess'));
            }
            catch (error) {
                showApiError(error, 'openDoorError');
            }
        }
        setModalVisible(false);
    };
    // src/sections/machine-detail/MachineDetail.tsx
    const handleResetMachine = async () => {
        const machineId = id ?? data?.machine?.machineId;
        if (!machineId) {
            setModalVisible(false);
            showError(t('restartMachineError'));
            return;
        }
        try {
            await (0, restartMachine_1.restartMachine)(repo, machineId);
            showSuccess(t('restartMachineSuccess'));
        }
        catch (error) {
            showApiError(error, 'restartMachineError');
        }
        finally {
            setModalVisible(false);
        }
    };
    const handleConfirm = async () => {
        if (actionType === 'openDoor') {
            await handleOpenDoor();
        }
        else if (actionType === 'resetMachine') {
            await handleResetMachine();
        }
    };
    const openConfirmationModal = (action) => {
        setActionType(action);
        setModalVisible(true);
    };
    const handleChangeProduct = async (productId, price) => {
        if (!aisleCode || !productId)
            return;
        try {
            setIsEditing(true);
            await (0, updatePriceOrProduct_1.updatePriceOrProduct)(repo, id ?? '', aisleCode, productId, price);
            setIsEditing(false);
            setChangeProductModalVisible(false);
            setTimeout(() => {
                showSuccess(t('updateProductSuccess'));
            }, 800);
        }
        catch (error) {
            setIsEditing(false);
            showApiError(error, 'updateProductError');
        }
    };
    const handleActiveRefills = () => {
        saveScrollPosition();
        // 1. Capturar snapshot usando aisleCode como clave
        const snapshot = aisles.reduce((acc, aisle) => {
            acc[aisle.aisleCode] = aisle.currStock; // Usamos currStock de Aisle
            return acc;
        }, {});
        // 2. Actualizar initialStockRefs
        initialStockRefs.current = snapshot;
        // 3. Activar modo reposición
        setInitialAislesState([...aisles]);
        setActiveRefills(true);
        setEditingField({ micronAisleId: null, field: 'inventory' });
        restoreScrollPosition();
    };
    const handleShowCalibration = () => {
        saveScrollPosition();
        setShowCalibration(!showCalibration);
        restoreScrollPosition();
    };
    const handleCloseActiveRefills = () => {
        saveScrollPosition();
        setAisles(initialAislesState ?? []);
        setActiveRefills(false);
        restoreScrollPosition();
    };
    const saveNewAisleWeight = async (newWeight) => {
        if (!currentAisle)
            return;
        if (!newWeight || newWeight <= 0) {
            showWarning(t('calibrationWeightRequired'));
            return;
        }
        try {
            await (0, updateAisleWeight_1.updateAisleWeight)(repo, id ?? '', currentAisle.aisleCode, newWeight);
            handleCloseCalibrationModal();
            showSuccess(t('updateAisleWeightSuccess'));
        }
        catch (error) {
            showApiError(error, 'updateAisleWeightError');
        }
    };
    // Reemplaza updateCurrStock con esta versión memoizada
    const updateCurrStock = (0, react_1.useCallback)((micronAisleId, increment) => {
        saveScrollPosition(); // Guarda posición antes de actualizar
        setAisles((prevAisles) => {
            const updatedItems = prevAisles.map((aisle) => aisle.micronAisleId === micronAisleId
                ? {
                    ...aisle,
                    currStock: increment
                        ? Math.min(aisle.currStock + 1, aisle.maxStock)
                        : Math.max(aisle.currStock - 1, 0),
                }
                : aisle);
            // Solo retorna nuevo estado si realmente hubo cambios
            if (prevAisles === updatedItems)
                return prevAisles;
            return updatedItems;
        });
        // Forzar actualización del DOM antes de restaurar scroll
        restoreScrollPosition();
    }, []);
    const updateCurrStockInput = (0, react_1.useCallback)((micronAisleId, value) => {
        saveScrollPosition();
        setAisles((prevAisles) => {
            const updatedItems = prevAisles.map((aisle) => aisle.micronAisleId === micronAisleId
                ? {
                    ...aisle,
                    currStock: value === null ? -1 : Math.min(value, aisle.maxStock),
                }
                : aisle);
            // Solo actualiza si realmente cambió algo
            if (prevAisles === updatedItems)
                return prevAisles;
            return updatedItems;
        });
        restoreScrollPosition();
    }, []);
    const generateRefills = () => aisles.map((aisle) => ({
        productId: aisle.micronProductId,
        aisleCode: aisle.aisleCode,
        price: aisle.price,
        weight: aisle.weight,
        currStock: aisle.currStock,
    }));
    const updateStocksAndHandleResponse = async (refills) => {
        try {
            await (0, updateStocks_1.updateStocks)(repo, id ?? '', refills);
            showSuccess(t('saveRefillsSuccess'));
            setActiveRefills(false);
        }
        catch (error) {
            showApiError(error, 'saveRefillsError');
        }
    };
    const handleConfirmContinueRefills = async () => {
        const refills = generateRefills();
        await updateStocksAndHandleResponse(refills);
        setOpenContinueRefillsModal(false);
    };
    const handleCancelContinueRefills = () => {
        setConfirmProceed(false);
        setOpenContinueRefillsModal(false);
    };
    const saveRefills = async () => {
        const changesMade = aisles.some((aisle, index) => {
            if (initialAislesState) {
                const initialAisle = initialAislesState[index];
                return initialAisle && aisle.currStock !== initialAisle.currStock;
            }
        });
        if (!changesMade) {
            setOpenContinueRefillsModal(true);
            return;
        }
        const hasInvalidStock = aisles.some((aisle) => aisle.currStock === -1);
        if (hasInvalidStock) {
            showError(t('inventory_invalid_stock'));
            return;
        }
        const refills = generateRefills();
        await updateStocksAndHandleResponse(refills);
    };
    const getWeight = async (event, aisle) => {
        // 2. Prevenir comportamiento por defecto
        if ('preventDefault' in event) {
            event.preventDefault();
            event.stopPropagation();
        }
        saveScrollPosition(); // Guarda posición antes de actualizar
        setLoadingWeights((prev) => ({ ...prev, [aisle.micronAisleId]: true }));
        // Asegúrate de pasar un SyntheticEvent al toggle
        const syntheticEvent = 'nativeEvent' in event
            ? event
            : 'originalEvent' in event
                ? event.originalEvent
                : null;
        if (syntheticEvent) {
            overlayRefs.current[aisle.micronAisleId]?.toggle(syntheticEvent);
        }
        setVisiblePopups((prev) => ({ ...prev, [aisle.micronAisleId]: true }));
        try {
            const res = await (0, getAisleWeight_1.getAisleWeight)(repo, id ?? '', aisle.aisleCode);
            if (res != null) {
                setWeights((prev) => ({ ...prev, [aisle.micronAisleId]: res }));
            }
        }
        catch (error) {
            showApiError(error, 'getWeightAisleError');
        }
        finally {
            setLoadingWeights((prev) => ({ ...prev, [aisle.micronAisleId]: false }));
        }
        restoreScrollPosition();
        setTimeout(() => {
            overlayRefs.current[aisle.micronAisleId]?.hide();
            setVisiblePopups((prev) => ({ ...prev, [aisle.micronAisleId]: false }));
        }, 4000);
    };
    const getBalanceMachine = async () => {
        setLoadingAllStock(true);
        try {
            const res = (await (0, getBalance_1.getBalance)(repo, id ?? ''));
            setAisles((prevAisles) => prevAisles.map((item) => {
                const updatedItem = res.find((r) => r.micronAisleId === item.micronAisleId);
                if (updatedItem) {
                    return {
                        ...item,
                        currStock: updatedItem.newStock,
                    };
                }
                return item;
            }));
            showSuccess(t('getWeightAllAislesSuccess'));
        }
        catch (error) {
            showApiError(error, 'getWeightAllAislesError');
        }
        finally {
            setLoadingAllStock(false);
        }
    };
    const getBalanceAisle = async (aisle) => {
        setLoadingStock((prev) => ({ ...prev, [aisle.micronAisleId]: true }));
        saveScrollPosition();
        try {
            const res = (await (0, getAisleBalance_1.getAisleBalance)(repo, aisle.aisleCode, id ?? ''));
            setAisles((prevAisles) => prevAisles.map((item) => item.micronAisleId === aisle.micronAisleId
                ? { ...item, currStock: res.newStock }
                : item));
            restoreScrollPosition();
        }
        catch (error) {
            showApiError(error, 'getBalanceAisleError');
        }
        finally {
            setLoadingStock((prev) => ({ ...prev, [aisle.micronAisleId]: false }));
        }
    };
    const getResetAisleWeight = async (aisle) => {
        try {
            await (0, resetAisleWeight_1.resetAisleWeight)(repo, id ?? '', aisle.aisleCode);
            showSuccess(t('resetAisleWeightSuccess'));
        }
        catch (error) {
            showApiError(error, 'resetAisleWeightError');
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(toast_1.Toast, { className: isMobile ? 'w-3/4 text-xs' : 'w-full', ref: toast }), openContinueRefillsModal && ((0, jsx_runtime_1.jsxs)(CustomModal_1.CustomModal, { title: t('continueWithoutChanges'), visible: openContinueRefillsModal, onHide: () => setOpenContinueRefillsModal(false), closable: false, children: [(0, jsx_runtime_1.jsx)("div", { className: machineDetail_module_scss_1.default.contentModal, children: (0, jsx_runtime_1.jsx)("p", { children: t('continueWithoutChangesMessage') }) }), (0, jsx_runtime_1.jsxs)("div", { className: machineDetail_module_scss_1.default.buttonContainer, children: [(0, jsx_runtime_1.jsx)(GenericButton_1.GenericButton, { className: machineDetail_module_scss_1.default.acceptButtonModal, label: t('accept'), onClick: handleConfirmContinueRefills }), (0, jsx_runtime_1.jsx)(GenericButton_1.GenericButton, { className: machineDetail_module_scss_1.default.cancelButtonModal, label: t('cancel'), onClick: handleCancelContinueRefills })] })] })), openCalibrationModal && ((0, jsx_runtime_1.jsx)("div", { className: "card flex justify-content-center", children: (0, jsx_runtime_1.jsx)(CustomModal_1.CustomModal, { title: t('calibration'), visible: openCalibrationModal, onHide: handleCloseCalibrationModal, children: (0, jsx_runtime_1.jsx)(CalibrationModal_1.CalibrationModal, { aisle: currentAisle, saveCalibration: saveNewAisleWeight }) }) })), (0, jsx_runtime_1.jsx)("div", { className: 'pt-5 pl-1 w-10', children: (0, jsx_runtime_1.jsx)(button_1.Button, { icon: 'pi pi-arrow-left', className: machineDetail_module_scss_1.default.backButton, tooltip: t('back'), tooltipOptions: {
                        position: 'bottom',
                        mouseTrack: true,
                        mouseTrackTop: 15,
                        className: 'custom-tooltip',
                    }, onClick: () => navigate(constants_1.ROUTE_MACHINE_LIST) }) }), (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(CardHeader_1.CardHeader, { id: id ?? '', machineName: data?.machine?.machineName ?? '', machineStatus: data?.machine?.micronOnlineStatus ?? false, handlerOpenDoor: (machineId) => openConfirmationModal('openDoor'), handlerResetMachine: (machineId) => openConfirmationModal('resetMachine'), handleActiveRefills: handleActiveRefills, handleCloseActiveRefills: handleCloseActiveRefills, saveRefills: saveRefills, activeRefills: activeRefills, getBalanceMachine: getBalanceMachine, handleShowCalibration: handleShowCalibration, showCalibration: showCalibration, loadingAllStocks: loadingAllStock }), (0, jsx_runtime_1.jsxs)(CustomModal_1.CustomModal, { title: ' ', visible: modalVisible, onHide: () => setModalVisible(false), closable: false, children: [(0, jsx_runtime_1.jsx)("p", { className: machineDetail_module_scss_1.default.contentModal, children: actionType === 'openDoor'
                                    ? t('confirmOpenDoorMessage')
                                    : t('confirmRestartMachineMessage') }), (0, jsx_runtime_1.jsxs)("div", { className: machineDetail_module_scss_1.default.buttonContainer, children: [(0, jsx_runtime_1.jsx)(GenericButton_1.GenericButton, { className: machineDetail_module_scss_1.default.acceptButtonModal, label: t('accept'), onClick: handleConfirm }), (0, jsx_runtime_1.jsx)(GenericButton_1.GenericButton, { className: machineDetail_module_scss_1.default.cancelButtonModal, label: t('cancel'), onClick: () => setModalVisible(false) })] })] }), isMobile ? ((0, jsx_runtime_1.jsx)("div", { style: { paddingBottom: '5rem' }, children: (0, jsx_runtime_1.jsx)(MachineDetail_1.MobileMachineDetail, { aisles: aisles, handleInputChange: handleInputChange, toggleEdit: toggleEdit, handleOpenChangeProductModal: handleOpenChangeProductModal, id: id ?? '', handlerOpenDoor: () => openConfirmationModal('openDoor'), handlerResetMachine: () => openConfirmationModal('resetMachine'), productData: productData, handleChangeProduct: handleChangeProduct, changeProductModalVisible: changeProductModalVisible, handleCloseChangeProductModal: handleCloseChangeProductModal, updateAisleValues: updateAisleValues, showSuccess: showSuccess, showError: showError, handleActiveRefills: handleActiveRefills, activeRefills: activeRefills, updateCurrStock: updateCurrStock, updateCurrStockInput: updateCurrStockInput, saveRefills: saveRefills, handleCloseActiveRefills: handleCloseActiveRefills, machineStatus: data?.machine?.micronOnlineStatus ?? false, loading: loadingAisles, getWeight: getWeight, weights: weights, loadingWeights: loadingWeights, overlayRefs: overlayRefs, visiblePopups: visiblePopups, getBalanceMachine: getBalanceMachine, initialStockRefs: initialStockRefs, getBalanceAisle: getBalanceAisle, showCalibration: showCalibration, getResetAisleWeight: getResetAisleWeight, handleOpenCalibrationModal: handleOpenCalibrationModal, handleShowCalibration: handleShowCalibration, productLoading: productLoading }) })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [changeProductModalVisible && ((0, jsx_runtime_1.jsx)(ChangeProductModal_1.ChangeProductModal, { products: productData.items, onSave: handleChangeProduct, onClose: handleCloseChangeProductModal, isOpen: changeProductModalVisible })), (0, jsx_runtime_1.jsx)(MemoizedDesktopGrid, { scrollContainerRef: scrollContainerRef, aisles: aisles, handleInputChange: handleInputChange, handleOpenChangeProductModal: handleOpenChangeProductModal, editingAisleId: editingAisleId, toggleEdit: toggleEdit, gridContainerRef: gridContainerRef, localValues: localValues, handleEditMode: handleEditMode, handleCloseEditMode: handleCloseEditMode, editingField: editingField, activeRefills: activeRefills, updateCurrStock: updateCurrStock, updateCurrStockInput: updateCurrStockInput, loading: loadingAisles, getWeight: getWeight, weights: weights, loadingWeights: loadingWeights, overlayRefs: overlayRefs, visiblePopups: visiblePopups, initialStockRefs: initialStockRefs, getBalanceAisle: getBalanceAisle, showCalibration: showCalibration, getResetAisleWeight: getResetAisleWeight, handleOpenCalibrationModal: handleOpenCalibrationModal, loadingStock: loadingStock })] }))] })] }));
};
exports.MachineDetail = MachineDetail;
const RenderSkeleton = () => {
    const isMobile = (0, useIsMobile_1.useIsMobile)();
    return isMobile ? ((0, jsx_runtime_1.jsxs)("div", { className: "p-4 mt-8 z-0", children: [(0, jsx_runtime_1.jsx)("div", { className: "mb-4", children: (0, jsx_runtime_1.jsx)(skeleton_1.Skeleton, { width: "100%", height: "4rem", className: "mb-2" }) }), (0, jsx_runtime_1.jsx)("div", { children: Array.from({ length: 7 }).map((_, index) => ((0, jsx_runtime_1.jsxs)("div", { className: "flex mb-4", children: [(0, jsx_runtime_1.jsx)(skeleton_1.Skeleton, { shape: "rectangle", size: "4rem", className: "mr-3 rounded-md" }), (0, jsx_runtime_1.jsx)(skeleton_1.Skeleton, { width: "90%", height: "4rem" })] }, index))) })] })) : ((0, jsx_runtime_1.jsx)("div", { className: machineDetail_module_scss_1.default.gridContainer, children: Array.from({ length: 7 }).map((_, index) => ((0, jsx_runtime_1.jsx)(WebCard_1.WebCard, { title: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("span", { className: machineDetail_module_scss_1.default.aislecode, children: (0, jsx_runtime_1.jsx)(skeleton_1.Skeleton, { width: "50%", height: "1.5rem", className: 'mb-4' }) }) }), (0, jsx_runtime_1.jsx)("span", { className: machineDetail_module_scss_1.default.title, children: (0, jsx_runtime_1.jsx)(skeleton_1.Skeleton, { width: "100%", height: "1.5rem", className: 'mb-4' }) })] }), customContent: (0, jsx_runtime_1.jsxs)("div", { className: machineDetail_module_scss_1.default.aisleContent, children: [(0, jsx_runtime_1.jsx)("div", { className: 'flex mb-2 justify-between items-center', children: (0, jsx_runtime_1.jsx)(skeleton_1.Skeleton, { width: "50%", height: "1.5rem" }) }), (0, jsx_runtime_1.jsx)("div", { className: 'flex mt-2 justify-between items-center', children: (0, jsx_runtime_1.jsx)(skeleton_1.Skeleton, { width: "50%", height: "1.5rem" }) }), (0, jsx_runtime_1.jsxs)("div", { className: 'flex justify-between items-center mt-2', children: [(0, jsx_runtime_1.jsx)(skeleton_1.Skeleton, { width: "50%", height: "1.5rem" }), (0, jsx_runtime_1.jsx)("div", { className: 'flex', children: (0, jsx_runtime_1.jsx)(skeleton_1.Skeleton, { width: "1.5rem", height: "1.5rem", className: machineDetail_module_scss_1.default.iconButtonFooter }) })] }), (0, jsx_runtime_1.jsx)("div", { className: machineDetail_module_scss_1.default.errorContainer })] }), contentEdit: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}), imageSrc: '', header: (0, jsx_runtime_1.jsx)("div", { className: machineDetail_module_scss_1.default.aisleContent, children: (0, jsx_runtime_1.jsx)("div", { className: 'flex flex-col justify-between items-center', children: (0, jsx_runtime_1.jsx)("div", { className: 'w-full flex justify-end mt-4', children: (0, jsx_runtime_1.jsx)(skeleton_1.Skeleton, { width: "11.5rem", height: "7.5rem" }) }) }) }), isEditing: false }, index))) }));
};
exports.RenderSkeleton = RenderSkeleton;
